import React, { useState } from 'react'

import { ExitPrompt, ExitPromptType } from '@frame/ui-components/exit-prompt'
import { WidgetHeaderWithNavigation } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'
import { H2 } from '@frame/ui-primitives/h2'

import { DirectTask } from '@frame/lib/api/tasks/types'
import { useShowExitPrompt } from '@frame/lib/hooks/useShowExitPrompt'
import { DataAttribute } from '@frame/types'

import { TaskFooter } from '../../components/task-footer'
import { useVerifyTask } from '../../hooks/useVerifyTask'
import { TaskContent } from './task-content'

type Props = {
  incomeTasks: DirectTask[]
  employmentTasks: DirectTask[]
}

export function IncomeOnlyTasks({ incomeTasks, employmentTasks }: Props) {
  const showExitPrompt = useShowExitPrompt()
  const { loadingTaskId, handleConnectBank, handleVerify } = useVerifyTask()
  const [showIncompletePrompt, setShowIncompletePrompt] = useState(false)

  return (
    <>
      <WidgetHeaderWithNavigation showCobranding backButton={{ visible: false }} showExitPrompt={showExitPrompt} />
      <Body data-cy={DataAttribute.SCREEN_INCOME_ONLY_TASKS} className="p-5" paddingTopOverride={8}>
        <H2 className="mb-4 text-left text-moss-700">Select the option that best describes you</H2>
        <TaskContent
          incomeTasks={incomeTasks}
          employmentTasks={employmentTasks}
          loadingTaskId={loadingTaskId}
          handleConnectBank={handleConnectBank}
          handleVerify={handleVerify}
        />
      </Body>
      <ExitPrompt
        show={showIncompletePrompt}
        hide={() => setShowIncompletePrompt(false)}
        title="Submit incomplete tasks?"
        type={ExitPromptType.INCOMPLETE}
      />
      <TaskFooter setShowIncompletePrompt={setShowIncompletePrompt} directTasks={employmentTasks} />
    </>
  )
}
